import styled from 'styled-components';
import { Button, Icon } from '@web-chat-core/ui-kit';

export const IconControlButton = styled.button`
    display: flex;
    align-items: center;
    border-radius: 60px;
    border: none;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    padding: 4px 16px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;

    &:active {
        border: none;
    }

    &:hover {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const IconedTextButton = styled(IconControlButton)`
    gap: 10px;

    &:hover {
        background-color: ${(props) => props.theme.root.colors.basicColors['15%']};
    }
`;

export const JoinCallButton = styled(Button)`
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 8px;
    height: 40px;

    ${Icon} {
        fill: rgb(255, 255, 255);
    }
`;
